export default {
  name: 'misc.occupation',
  key: 'occupation',
  attributes: {
    sectarians: {
      key: 'sectarians',
      name: 'entity.asteroidBase.occupation.sectarians',
    },
    rebels: {
      key: 'rebels',
      name: 'entity.asteroidBase.occupation.rebels',
    },
    miners: {
      key: 'miners',
      name: 'entity.asteroidBase.occupation.miners',
    },
    prospectors: {
      key: 'prospectors',
      name: 'entity.asteroidBase.occupation.prospectors',
    },
    pirates: {
      key: 'pirates',
      name: 'entity.asteroidBase.occupation.pirates',
    },
  },
};
